module.exports = __webpack_public_path__ + "static/media/professional-services-square.3b6c7729.jpg";